class TrackablePromise<T> extends Promise<T> {
    private waitNotifyHandlers: Function[];

    constructor(
        executor: (
            resolve: (value?: T | PromiseLike<T>) => void,
            reject: (reason?: any) => void,
            status?: (value?: any) => void,
        ) => void,
    ) {
        const notifyHandlers: any[] = [];

        super((resolve, reject) => {
            return executor(resolve, reject, (status) => {
                notifyHandlers.map((handler) => handler(status));
            });
        });
        this.waitNotifyHandlers = notifyHandlers;
    }

    notify(notifyHandler: Function) {
        this.waitNotifyHandlers.push(notifyHandler);
        return this;
    }
}

export default class WaitPromise<T> {
    private interval: number;
    private afterTime: number;
    private canceled = false;

    private current: TrackablePromise<T> | null = null;

    constructor(interval?: number, afterTime?: number) {
        this.interval = interval ?? 100;
        this.afterTime = afterTime ?? 0;
    }

    clean() {
        this.canceled = true;
    }

    until(cond: Function) {
        const interval = this.interval;
        const afterTime = this.afterTime;
        let timer = 0;
        this.canceled = false;
        this.current = new TrackablePromise<T>((resolve, reject) => {
            const f: Function = () => {
                let res;
                try {
                    res = cond();
                } catch (err) {
                    clearInterval(timer);
                } finally {
                    if (res) {
                        clearInterval(timer);
                        resolve(res);
                    }

                    if (this.canceled) {
                        clearInterval(timer);
                        reject({ reason: 'canceled' });
                    }
                }
            };

            setTimeout(function () {
                if (!f()) {
                    timer = setInterval(f, interval);
                }
            }, afterTime);
        });

        return this.current;
    }
}
